module.exports = __webpack_public_path__ + "img/Mosque_Photo.fdab3861.jpg";